<!-- ══════ Create / Edit Payer ══════ -->
<div style="padding: 24px 16px; max-width: 900px; margin: 0 auto;">
  <div style="background: white; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.08); border: 1px solid #e5e7eb; overflow: hidden;">

    <!-- ── Header gradiente ── -->
    <div style="background: linear-gradient(135deg, #1e5a3f 0%, #059669 100%); padding: 24px 28px; text-align: center;">
      <div style="display: flex; align-items: center; justify-content: center; gap: 10px;">
        <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: #a7f3d0;">
          {{ !esEditar ? 'person_add' : 'edit' }}
        </mat-icon>
        <h1 style="margin: 0; font-size: 1.35rem; font-weight: 800; color: white; letter-spacing: 0.3px;">
          {{ !esEditar ? 'Registrar pagador' : 'Editar pagador'}}
        </h1>
      </div>
      <p style="margin: 6px 0 0; font-size: 0.82rem; color: #a7f3d0; font-weight: 400;">
        {{ this.tipoUsuario === 0 ? 'Persona' : 'Empresa'}}
      </p>
    </div>

    <!-- ── Body ── -->
    <div style="padding: 28px 24px;">

      <!-- ── Admin: ID usuario ── -->
      <div *ngIf="isAdmin"
        style="display: flex; align-items: center; gap: 8px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; padding: 10px 16px; margin-bottom: 20px;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">badge</mat-icon>
        <span style="font-size: 0.85rem; font-weight: 600; color: #1e5a3f;">ID del usuario: {{this.data?.id}}</span>
      </div>

      <!-- ── Toggle Persona / Empresa ── -->
      <div *ngIf="!esEditar"
        style="display: flex; justify-content: center; gap: 12px; margin-bottom: 24px;">
        <button type="button" (click)="toggleTipoUsuario('persona')"
          [style.background]="tipoUsuario === 0 ? '#1C593D' : 'white'"
          [style.color]="tipoUsuario === 0 ? 'white' : '#374151'"
          [style.border]="tipoUsuario === 0 ? 'none' : '1px solid #d1d5db'"
          style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 32px; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: all 0.2s ease;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px;"
            [style.color]="tipoUsuario === 0 ? 'white' : '#6b7280'">person</mat-icon>
          Persona
        </button>
        <button type="button" (click)="toggleTipoUsuario('empresa')"
          [style.background]="tipoUsuario === 1 ? '#1C593D' : 'white'"
          [style.color]="tipoUsuario === 1 ? 'white' : '#374151'"
          [style.border]="tipoUsuario === 1 ? 'none' : '1px solid #d1d5db'"
          style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 32px; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: all 0.2s ease;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px;"
            [style.color]="tipoUsuario === 1 ? 'white' : '#6b7280'">business</mat-icon>
          Empresa
        </button>
      </div>

      <!-- ══════ FORMULARIO ══════ -->
      <form [formGroup]="datosForm" *ngIf="datosForm" (ngSubmit)="enviarDatos()">

        <!-- ── Cliente editando: la identidad no se cambia ── -->
        <div *ngIf="identidadBloqueada"
          style="display: flex; align-items: flex-start; gap: 8px; background: #fffbeb; border: 1px solid #fde68a; border-radius: 10px; padding: 10px 14px; margin-bottom: 20px;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #b45309; flex-shrink: 0;">lock</mat-icon>
          <span style="font-size: 0.8rem; color: #92400e; line-height: 1.4;">
            El nombre, el documento y la razón social del pagador no se pueden modificar.
            Si hay un error en esos datos, contacta a soporte.
            Si cambias fotos, documentos, nacionalidad o sexo, el pagador vuelve a revisión y
            no recibe abonos hasta que lo aprobemos. Los datos de contacto se cambian sin revisión.
          </span>
        </div>

        <!-- ── Sección: Datos Persona / Representante Legal ── -->
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">person</mat-icon>
          <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">
            {{ this.tipoUsuario === 0 ? 'Datos personales' : 'Representante legal'}}
          </span>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Nombre</mat-label>
            <input type="text" matInput pattern="[ a-zA-Z]*" formControlName="nombre"
              placeholder="Ingresa tu nombre" />
            <mat-error *ngIf="this.datosForm.get('nombre')!.hasError('pattern')">
              Sólo caracteres alfábeticos
            </mat-error>
            <mat-error *ngIf="this.datosForm.get('nombre')!.hasError('maxlength')">
              Máximo 40 caracteres
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Apellidos</mat-label>
            <input type="text" matInput pattern="[ a-zA-Z]*" formControlName="apellidos"
              placeholder="Ingresa tu apellido" />
            <mat-error *ngIf="this.datosForm.get('apellidos')!.hasError('pattern')">
              Sólo caracteres alfábeticos
            </mat-error>
            <mat-error *ngIf="this.datosForm.get('apellidos')!.hasError('maxlength')">
              Máximo 40 caracteres
            </mat-error>
          </mat-form-field>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Tipo documento</mat-label>
            <mat-select required formControlName="tipoId">
              <mat-option>Tipo documento</mat-option>
              <mat-option *ngFor="let tipoID of tiposID" [value]="tipoID">
                {{ tipoID }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Numero identificación</mat-label>
            <input type="text" matInput formControlName="numeroId"
              placeholder="Ingresa tu documento" (blur)="checkPayer('numeroId')" />
            <mat-error *ngIf="this.datosForm.get('numeroId')!.hasError('maxlength')">
              Máximo 15 caracteres
            </mat-error>
          </mat-form-field>
        </div>

        <!-- ── Separador ── -->
        <div style="height: 1px; background: #e5e7eb; margin: 16px 0 20px;"></div>

        <!-- ── Sección: Contacto ── -->
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">phone</mat-icon>
          <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Contacto</span>
        </div>

        <div class="grid grid-cols-3 sm:grid-cols-3 gap-x-4 gap-y-1">
          <mat-form-field appearance="outline" class="col-span-3 sm:col-span-1 modern-field">
            <mat-label>Código</mat-label>
            <input type="text" placeholder="Selecciona uno" aria-label="Number" matInput
              formControlName="prefijoTelefono" [matAutocomplete]="auto" (blur)="checkPrefijo()" />
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option *ngFor="let pais of optionsPrefijoTelefono | async" [value]="pais.DIAL"
                class="flex flex-row">
                <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                <span> {{ pais.DIAL }} - {{ pais.NAME | titlecase }} </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="outline" class="col-span-3 sm:col-span-2 modern-field">
            <mat-label>Teléfono</mat-label>
            <input type="text" matInput appOnlynumber formControlName="telefono"
              placeholder="Ingresa tu Teléfono" />
          </mat-form-field>
        </div>

        <!-- ══════ Campos solo Persona (tipoUsuario === 0) ══════ -->
        <div *ngIf="tipoUsuario === 0">

          <!-- ── Separador ── -->
          <div style="height: 1px; background: #e5e7eb; margin: 16px 0 20px;"></div>

          <!-- ── Sección: Información adicional ── -->
          <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">info</mat-icon>
            <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Información adicional</span>
          </div>

          <div class="grid grid-cols-1 gap-y-1">
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Nacionalidad</mat-label>
              <input type="text" placeholder="Selecciona un país" matInput formControlName="nacionalidad"
                required [matAutocomplete]="autoPaisNacionalidad" (blur)="checkPais('nacionalidad')" />
              <mat-autocomplete autoActiveFirstOption #autoPaisNacionalidad="matAutocomplete">
                <mat-option *ngFor="let pais of optionsNacionalidad | async" [value]="pais.NAME"
                  class="flex flex-row">
                  <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                  <span> {{ pais.NAME | titlecase }} </span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="grid grid-cols-3 sm:grid-cols-3 gap-x-4 gap-y-1">
            <mat-form-field appearance="outline" class="col-span-3 sm:col-span-1 modern-field">
              <mat-label>Sexo</mat-label>
              <mat-select required formControlName="sexo">
                <mat-option>Selecciona una opción</mat-option>
                <mat-option *ngFor="let sexo of sexos" [value]="sexo" class="flex flex-row">
                  <span> {{ sexo }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-span-3 sm:col-span-2 modern-field">
              <mat-label>Selecciona tu fecha</mat-label>
              <input matInput formControlName="fechaNacimiento" [matDatepicker]="picker" [max]="maxDate" />
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- ── Separador ── -->
          <div style="height: 1px; background: #e5e7eb; margin: 16px 0 20px;"></div>

          <!-- ── Sección: Residencia ── -->
          <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">location_on</mat-icon>
            <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Residencia</span>
          </div>

          <div class="grid grid-cols-1 gap-y-1">
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>País de residencia</mat-label>
              <input type="text" placeholder="Selecciona un país" aria-label="Number" matInput
                formControlName="paisResidencia" [matAutocomplete]="autoPais"
                (blur)="checkPais('paisResidencia')" />
              <mat-autocomplete autoActiveFirstOption #autoPais="matAutocomplete">
                <mat-option *ngFor="let pais of optionsPaisResidencia | async" [value]="pais.NAME"
                  class="flex flex-row">
                  <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                  <span> {{ pais.NAME | titlecase }} </span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="grid grid-cols-1 gap-y-1">
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Ciudad de residencia</mat-label>
              <input type="text" matInput formControlName="ciudadResidencia" placeholder="Ej. Santiago" />
            </mat-form-field>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Dirección</mat-label>
              <input type="text" matInput formControlName="direccion" placeholder="Ej. Santiago" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Profesión</mat-label>
              <input type="text" matInput formControlName="profesion" placeholder="Ej. Ingeniero" />
            </mat-form-field>
          </div>
        </div>

        <!-- ── Separador ── -->
        <div style="height: 1px; background: #e5e7eb; margin: 16px 0 20px;"></div>

        <!-- ── Sección: Documentos ── -->
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">description</mat-icon>
          <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Documentos</span>
        </div>

        <!-- ══ Modo Editar: preview + file input ══ -->
        <div *ngIf="esEditar; else imageEditar">
          <div style="display: flex; flex-direction: column; gap: 8px;">

            <!-- Doc Frontal (edit) -->
            <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">photo_camera</mat-icon>
                <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">Imagen frontal del documento</span>
              </div>
              <img *ngIf="fotoIdFrontal" [src]="fotoIdFrontal" [alt]="fotoIdFrontal"
                style="max-width: 200px; border-radius: 8px; margin: 0 auto 12px; display: block; border: 1px solid #e5e7eb;" />
              <div style="display: flex; justify-content: center;">
                <div class="file-select" id="src-file1"
                  style="border: 2px solid #1C593D; border-radius: 10px; display: inline-block;">
                  <input type="file" #fileInputFrontal
                    (change)="showPreview($event, 'documentoFrontal')"
                    accept=".png, .jpg, .jpeg" formControlName="documentoFrontal"
                    style="cursor: pointer;" />
                </div>
              </div>
              <div *ngIf="this.datosForm.controls['documentoFrontal'].invalid && (this.datosForm.controls['documentoFrontal'].dirty || this.datosForm.controls['documentoFrontal'].touched)"
                class="error-file alert">
                <mat-error class="error-file" *ngIf="this.datosForm.get('documentoFrontal')!.errors!['maxSize']">
                  Máximo 5 MB
                </mat-error>
                <mat-error class="error-file" *ngIf="this.datosForm.get('documentoFrontal')!.errors!['incorrectFormat']">
                  Únicamente formatos JPG o PNG
                </mat-error>
              </div>
            </div>

            <!-- Doc Posterior (edit) -->
            <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">photo_camera</mat-icon>
                <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">Imagen posterior del documento</span>
              </div>
              <img *ngIf="fotoIdPosterior" [src]="fotoIdPosterior" [alt]="fotoIdPosterior"
                style="max-width: 200px; border-radius: 8px; margin: 0 auto 12px; display: block; border: 1px solid #e5e7eb;" />
              <div style="display: flex; justify-content: center;">
                <div class="file-select" id="src-file2"
                  style="border: 2px solid #1C593D; border-radius: 10px; display: inline-block;">
                  <input type="file" #fileInputPosterior
                    (change)="showPreview($event, 'documentoPosterior')"
                    accept=".png, .jpg, .jpeg" formControlName="documentoPosterior"
                    style="cursor: pointer;" />
                </div>
              </div>
              <div *ngIf="this.datosForm.controls['documentoPosterior'].invalid && (this.datosForm.controls['documentoPosterior'].dirty || this.datosForm.controls['documentoPosterior'].touched)"
                class="error-file alert">
                <mat-error class="error-file" *ngIf="this.datosForm.get('documentoPosterior')!.errors!['maxSize']">
                  Máximo 5 MB
                </mat-error>
                <mat-error class="error-file" *ngIf="this.datosForm.get('documentoPosterior')!.errors!['incorrectFormat']">
                  Únicamente formatos JPG o PNG
                </mat-error>
              </div>
            </div>
          </div>

          <!-- ══ Empresa (edit mode) ══ -->
          <div *ngIf="tipoUsuario === 1" style="margin-top: 20px;">

            <!-- ── Separador ── -->
            <div style="height: 1px; background: #e5e7eb; margin: 16px 0 20px;"></div>

            <!-- ── Sección: Empresa ── -->
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
              <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">business</mat-icon>
              <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Empresa</span>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
              <mat-form-field appearance="outline" class="modern-field">
                <mat-label>Nombre o Razón Social</mat-label>
                <input type="text" matInput formControlName="razonSocial"
                  placeholder="Ingresa la razón social" />
                <mat-error *ngIf="this.datosForm.get('razonSocial')!.hasError('maxlength')">
                  Máximo 40 caracteres
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="modern-field">
                <mat-label>Nombre comercial</mat-label>
                <input type="text" matInput formControlName="nombreComercial"
                  placeholder="Ingresa el nombre comercial" />
                <mat-error *ngIf="this.datosForm.get('nombreComercial')!.hasError('maxlength')">
                  Máximo 40 caracteres
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="modern-field">
                <mat-label>Rut Empresa</mat-label>
                <input (blur)="validateRutEmpresa()" type="text" matInput formControlName="rutEmpresa"
                  placeholder="Ingresa tu documento" />
                <div *ngIf="this.datosForm.controls['rutEmpresa'].invalid &&
                    (this.datosForm.controls['rutEmpresa'].dirty || this.datosForm.controls['rutEmpresa'].touched)"
                  class="error-file alert">
                  <mat-error *ngIf="this.datosForm.get('rutEmpresa')!.errors!['incorrectFormat'] === true">
                    Ingrese un rut válido
                  </mat-error>
                  <mat-error *ngIf="this.datosForm.get('rutEmpresa')!.hasError('maxlength')">
                    Máximo 15 caracteres
                  </mat-error>
                </div>
              </mat-form-field>

              <mat-form-field appearance="outline" class="modern-field">
                <mat-label>Domicilio fiscal</mat-label>
                <input type="text" matInput formControlName="domicilioFiscal" placeholder="Ej. Santiago" />
                <mat-error *ngIf="this.datosForm.get('domicilioFiscal')!.hasError('maxlength')">
                  Máximo 60 caracteres
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Docs Empresa (edit) -->
            <div style="display: flex; flex-direction: column; gap: 8px; margin-top: 12px;">
              <!-- Estatuto -->
              <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">gavel</mat-icon>
                  <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">Estatuto constitutivo</span>
                </div>
                <img *ngIf="estatuto && !this.pagador?.estatuto?.includes('.pdf')" [src]="estatuto" [alt]="estatuto"
                  style="max-width: 200px; border-radius: 8px; margin: 0 auto 12px; display: block; border: 1px solid #e5e7eb;" />
                <div style="display: flex; justify-content: center;">
                  <div class="file-select" id="src-file4"
                    style="border: 2px solid #1C593D; border-radius: 10px; display: inline-block;">
                    <input type="file" #fileEstatuto
                      (change)="showPreview($event, 'estatuto')"
                      accept="image/*, .pdf" formControlName="estatuto"
                      style="cursor: pointer;" />
                  </div>
                </div>
                <div *ngIf="this.datosForm.controls['estatuto'].invalid && (this.datosForm.controls['estatuto'].dirty || this.datosForm.controls['estatuto'].touched)"
                  class="error-file alert">
                  <mat-error class="error-file" *ngIf="this.datosForm.get('estatuto')!.errors!['maxSize']">
                    Máximo 5 MB
                  </mat-error>
                  <mat-error class="error-file" *ngIf="this.datosForm.get('estatuto')!.errors!['incorrectFormat']">
                    Únicamente formatos JPG o PNG
                  </mat-error>
                </div>
              </div>

              <!-- E-RUT -->
              <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">article</mat-icon>
                  <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">E-RUT de la empresa</span>
                </div>
                <img *ngIf="erut && !this.pagador?.e_rut?.includes('.pdf')" [src]="erut" [alt]="erut"
                  style="max-width: 200px; border-radius: 8px; margin: 0 auto 12px; display: block; border: 1px solid #e5e7eb;" />
                <div style="display: flex; justify-content: center;">
                  <div class="file-select" id="src-file3"
                    style="border: 2px solid #1C593D; border-radius: 10px; display: inline-block;">
                    <input type="file" #fileRutE
                      (change)="showPreview($event, 'e_rut')"
                      accept="image/*, .pdf" formControlName="e_rut"
                      style="cursor: pointer;" />
                  </div>
                </div>
                <div *ngIf="this.datosForm.controls['e_rut'].invalid && (this.datosForm.controls['e_rut'].dirty || this.datosForm.controls['e_rut'].touched)"
                  class="error-file alert">
                  <mat-error class="error-file" *ngIf="this.datosForm.get('e_rut')!.errors!['maxSize']">
                    Máximo 5 MB
                  </mat-error>
                  <mat-error class="error-file" *ngIf="this.datosForm.get('e_rut')!.errors!['incorrectFormat']">
                    Únicamente formatos JPG o PNG
                  </mat-error>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ══ Modo Crear: ngx-mat-file-input ══ -->
        <ng-template #imageEditar>
          <div style="display: flex; flex-direction: column; gap: 8px;">
            <!-- Doc Frontal (create) -->
            <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">photo_camera</mat-icon>
                <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">Imagen frontal del documento</span>
              </div>
              <mat-form-field appearance="outline" class="w-full modern-field">
                <ngx-mat-file-input class="w-full" #fileInputFrontal formControlName="documentoFrontal"
                  [multiple]="false" [accept]="'image/*'" color="primary"
                  placeholder="Adjunte imagen frontal de su documento">
                </ngx-mat-file-input>
                <div *ngIf="this.datosForm.controls['documentoFrontal'].invalid && (this.datosForm.controls['documentoFrontal'].dirty || this.datosForm.controls['documentoFrontal'].touched)"
                  class="error-file alert">
                  <mat-error class="error-file" *ngIf="this.datosForm.get('documentoFrontal')!.errors!['maxSize']">
                    Máximo 5 MB
                  </mat-error>
                  <mat-error class="error-file" *ngIf="this.datosForm.get('documentoFrontal')!.errors!['incorrectFormat']">
                    Únicamente formatos JPG o PNG
                  </mat-error>
                </div>
              </mat-form-field>
            </div>

            <!-- Doc Posterior (create) -->
            <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">photo_camera</mat-icon>
                <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">Imagen posterior del documento</span>
              </div>
              <mat-form-field appearance="outline" class="w-full modern-field">
                <ngx-mat-file-input [multiple]="false" formControlName="documentoPosterior"
                  #fileInputPosterior [accept]="'image/*'" color="primary"
                  placeholder="Adjunte imagen posterior de su documento">
                </ngx-mat-file-input>
                <div *ngIf="this.datosForm.controls['documentoPosterior'].invalid && (this.datosForm.controls['documentoPosterior'].dirty || this.datosForm.controls['documentoPosterior'].touched)"
                  class="error-file alert">
                  <mat-error class="error-file" *ngIf="this.datosForm.get('documentoPosterior')!.errors!['maxSize']">
                    Máximo 5 MB
                  </mat-error>
                  <mat-error class="error-file" *ngIf="this.datosForm.get('documentoPosterior')!.errors!['incorrectFormat']">
                    Únicamente formatos JPG o PNG
                  </mat-error>
                </div>
              </mat-form-field>
            </div>
          </div>

          <!-- ══ Empresa (create mode) ══ -->
          <div *ngIf="tipoUsuario === 1" style="margin-top: 20px;">

            <!-- ── Separador ── -->
            <div style="height: 1px; background: #e5e7eb; margin: 16px 0 20px;"></div>

            <!-- ── Sección: Empresa ── -->
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 18px;">
              <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">business</mat-icon>
              <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Empresa</span>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
              <mat-form-field appearance="outline" class="modern-field">
                <mat-label>Nombre o Razón Social</mat-label>
                <input type="text" matInput formControlName="razonSocial"
                  placeholder="Ingresa la razón social" />
                <mat-error *ngIf="this.datosForm.get('razonSocial')!.hasError('maxlength')">
                  Máximo 40 caracteres
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="modern-field">
                <mat-label>Nombre comercial</mat-label>
                <input type="text" matInput formControlName="nombreComercial"
                  placeholder="Ingresa el nombre comercial" />
                <mat-error *ngIf="this.datosForm.get('nombreComercial')!.hasError('maxlength')">
                  Máximo 40 caracteres
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="modern-field">
                <mat-label>Rut Empresa</mat-label>
                <input (blur)="validateRutEmpresa()" type="text" matInput formControlName="rutEmpresa"
                  placeholder="Ingresa tu documento" />
                <div *ngIf="this.datosForm.controls['rutEmpresa'].invalid &&
                    (this.datosForm.controls['rutEmpresa'].dirty || this.datosForm.controls['rutEmpresa'].touched)"
                  class="error-file alert">
                  <mat-error *ngIf="this.datosForm.get('rutEmpresa')!.errors!['incorrectFormat'] === true">
                    Ingrese un rut válido
                  </mat-error>
                  <mat-error *ngIf="this.datosForm.get('rutEmpresa')!.hasError('maxlength')">
                    Máximo 15 caracteres
                  </mat-error>
                </div>
              </mat-form-field>

              <mat-form-field appearance="outline" class="modern-field">
                <mat-label>Domicilio fiscal</mat-label>
                <input type="text" matInput formControlName="domicilioFiscal" placeholder="Ej. Santiago" />
                <mat-error *ngIf="this.datosForm.get('domicilioFiscal')!.hasError('maxlength')">
                  Máximo 60 caracteres
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Docs Empresa (create) -->
            <div style="display: flex; flex-direction: column; gap: 8px; margin-top: 12px;">
              <!-- Estatuto -->
              <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">gavel</mat-icon>
                  <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">Estatuto constitutivo</span>
                </div>
                <mat-form-field appearance="outline" class="w-full modern-field">
                  <ngx-mat-file-input [multiple]="false" formControlName="estatuto"
                    #fileInputEstatuto [accept]="'image/*, .pdf'" color="primary"
                    (change)="showPreview($event, 'estatuto')"
                    placeholder="Adjunte Estatuto constitutivo de la empresa">
                  </ngx-mat-file-input>
                  <div *ngIf="this.datosForm.controls['estatuto'].invalid &&
                      (this.datosForm.controls['estatuto'].dirty || this.datosForm.controls['estatuto'].touched)"
                    class="error-file alert">
                    <mat-error class="error-file" *ngIf="this.datosForm.get('estatuto')!.errors!['maxSize']">
                      Máximo 5 MB
                    </mat-error>
                    <mat-error class="error-file" *ngIf="this.datosForm.get('estatuto')!.errors!['incorrectFormat']">
                      Únicamente formatos JPG, PNG o PDF
                    </mat-error>
                  </div>
                </mat-form-field>
              </div>

              <!-- E-RUT -->
              <div style="background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 12px; padding: 16px;">
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">article</mat-icon>
                  <span style="font-size: 0.82rem; font-weight: 600; color: #374151;">E-RUT de la empresa</span>
                </div>
                <mat-form-field appearance="outline" class="w-full modern-field">
                  <ngx-mat-file-input [multiple]="false" formControlName="e_rut"
                    [accept]="'image/*, .pdf'" color="primary" #fileInputERut
                    (change)="showPreview($event, 'e_rut')"
                    placeholder="Adjunte e-RUT de la empresa">
                  </ngx-mat-file-input>
                  <div *ngIf="this.datosForm.controls['e_rut'].invalid &&
                      (this.datosForm.controls['e_rut'].dirty || this.datosForm.controls['e_rut'].touched)"
                    class="error-file alert">
                    <mat-error class="error-file" *ngIf="this.datosForm.get('e_rut')!.errors!['maxSize']">
                      Máximo 5 MB
                    </mat-error>
                    <mat-error class="error-file" *ngIf="this.datosForm.get('e_rut')!.errors!['incorrectFormat']">
                      Únicamente formatos JPG, PNG o PDF
                    </mat-error>
                  </div>
                </mat-form-field>
              </div>
            </div>
          </div>
        </ng-template>

        <!-- ── Botones Acción ── -->
        <div style="display: flex; align-items: center; justify-content: center; gap: 12px; margin-top: 28px;">
          <button type="button" (click)="cancelar()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 28px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.88rem; cursor: pointer; transition: all 0.2s ease;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">arrow_back</mat-icon>
            Cancelar
          </button>
          <button type="submit" tabindex="1"
            [disabled]="!validPayerId"
            [style.opacity]="!validPayerId ? '0.5' : '1'"
            [style.cursor]="!validPayerId ? 'not-allowed' : 'pointer'"
            style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">send</mat-icon>
            Enviar datos
          </button>
        </div>
      </form>

    </div>
  </div>
</div>

<!-- Admin: botón cerrar dialog -->
<div *ngIf="isAdmin" style="display: flex; justify-content: flex-end; padding: 12px 16px 0;">
  <button type="button" (click)="cancelar()"
    style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
    onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">close</mat-icon>
    Cerrar
  </button>
</div>
